/**
 * JokesPage — placeholder canvas for jokes / one-liners.  Studio-themed
 * page reachable from the NavPane (per user iter 134).
 *
 * Jokes are stored as a simple in-file list so they can be edited in
 * future passes without wiring up a backend.
 */
import { useNavigate } from "react-router-dom";
import TopBar from "@/components/TopBar";
import NavPane from "@/components/NavPane";

const PAL = {
  bg: "#0F0E0C",
  ink: "#F5F1E8",
  muted: "#9C8E72",
  accent: "#E5C870",
  border: "rgba(229,200,112,0.18)",
};
const TIMES = "'Times New Roman',Times,serif";

const JOKES = [
  // Iter M632 — first two written-by-user entries. Each entry is a JSX
  // node so paragraph breaks render naturally.
  (
    <>
      <p style={{ marginBottom: "0.6em" }}>
        An American spy enters one of the few phone booths left in North America and makes a call.
        Before he can access the database of his covert organization, the automated voice system
        begins to ask him a couple of security questions.
      </p>
      <p style={{ marginBottom: "0.6em" }}>
        &mdash; &ldquo;Question 1: What was your favorite social sciences subject in college?&rdquo;
      </p>
      <p style={{ marginBottom: "0.6em" }}>&mdash; &ldquo;Prostitution in modern Japan.&rdquo;</p>
      <p style={{ marginBottom: "0.6em" }}>A few seconds of silence elapse.</p>
      <p style={{ marginBottom: "0.6em" }}>
        &mdash; &ldquo;Question 2: Where did you go to school?&rdquo;
      </p>
      <p style={{ marginBottom: "0.6em" }}>
        &mdash; &ldquo;Aus-TRY-lia.&rdquo; He quickly fixed his glasses after giving his answer.
      </p>
      <p style={{ marginBottom: 0 }}>&mdash; &ldquo;Access granted.&rdquo;</p>
    </>
  ),
  (
    <>
      <p style={{ marginBottom: "0.6em" }}>
        Steve is taking his co-workers, Rajesh riding the shotgun and Karen in the backseat, out
        for lunch.
      </p>
      <p style={{ marginBottom: "0.6em" }}>
        &mdash; &ldquo;You guys like In-N&rsquo;-Out?&rdquo; Steve asked?
      </p>
      <p style={{ marginBottom: "0.6em" }}>
        With excitement Karen responded in her contralto voice:
      </p>
      <p style={{ marginBottom: "0.6em" }}>
        &mdash; &ldquo;Oh, yeah! No matter the position!&rdquo;
      </p>
      <p style={{ marginBottom: 0 }}>
        The radiance on Raj and Steve&rsquo;s faces was replaced with bewilderment.
      </p>
    </>
  ),
  (
    <>
      <p style={{ marginBottom: "0.6em" }}>
        Am I the only one wondering why there are so many people in arts and
        engineering trying and failing to succeed and be prolific and be what
        they want to be in the Information Age?  There were people in history
        who already knew how to quickly figure out what they were best at.
        But we, we drug ourselves and chemically recondition ourselves.
        J. S. Bach wrote over 200 cantatas, 6 motets, 4 passions, 2 oratorios,
        4 masses, the Magnificat, etc. &mdash; that&rsquo;s over 1,100
        compositions &mdash; and had 20 children from two wives.  You think
        he did all of that by chugging gallons of Red Bull or C4 &hellip;
        through his rectum, standing on his fucking hands &hellip; while a
        member of a fraternity at the University of Maryland, &hellip;
        smoking crystal meth as his wig is brushing back and forth against
        the floor?  You think he did that?
      </p>
      <p style={{ marginBottom: 0 }}>
        How do you think the U.S. military is handling the whole
        neurodivergence &lsquo;epidemic&rsquo;?  Some candidates probably
        got turned away by the medical professionals.  Some probably
        managed to sneak their way in and couldn&rsquo;t back out,
        couldn&rsquo;t be forced out of the military.  How do you think
        they would be commandeered, or &lsquo;trained&rsquo;, to manage
        their ADHD?  Probably by standing on their hands, chugging gallons
        of Monster through the rectum like a bunch of frat boys at the
        University of Virginia.
      </p>
    </>
  ),
  (
    <>
      <p style={{ marginBottom: 0 }}>
        Have you ever watched a video clip on Instagram and thought to
        yourselves &lsquo;Oh, my God. &hellip; These people are so perfectly
        still in that clip. &hellip; Why?!&rsquo; &hellip; and then realized
        you are looking at a picture?  &hellip; Such an idiot.
      </p>
    </>
  ),
  (
    <>
      <p style={{ marginBottom: 0 }}>
        If I were to have a kid, it would be through adoption.  But, see,
        that presents a challenge: How do you approach that process?  Is
        it random or do you get to be selective?  And if you do get to be
        selective, would you approach it the same way as you would
        approach buying a car?  &lsquo;What kind do you want?  What color
        do you want?&rsquo;
      </p>
    </>
  ),
  (
    <>
      <p style={{ marginBottom: 0 }}>
        Have you ever walked into a room or boarded a bus or a train car
        and smelt something so pungent that you got annoyed?  The next
        time you find yourselves in a similar situation, this is what I
        advise: overreact.  Make your point.  The first time you were
        like &lsquo;Oof.&rsquo;  The second time you were like
        &lsquo;Oh.&rsquo;  That&rsquo;s not right.  The next time you
        find yourselves in a situation like this, just go: &lsquo;Oh,
        motherfuck me!  [Coughing] &hellip; Parabens again?! &hellip;
        The fuck is this, World War I trench warfare?!&rsquo;
      </p>
    </>
  ),
  (
    <>
      <p style={{ marginBottom: 0 }}>
        You like Emerson, Lake &amp; Palmer?  Keith Emerson, the
        keyboardist, used to do this insane shit live where he would stick
        a knife into his keyboard, like a Hammond B3, &hellip; and then
        another knife &hellip; and another knife.  And I&rsquo;m watching
        ELP live shows on YouTube, I&rsquo;m watching Keith Emerson
        sticking knives into his organ (no pun intended), thinking:
        &lsquo;&hellip; I could do that!  &hellip; Yeah!  I could totally
        do shit like that at a live show.  &hellip; I mean, I don&rsquo;t
        have a whole vast array of knives.  &hellip; I mean, &hellip; I
        have &hellip; thumbtacks.  &hellip; [Doing an impression of me
        sticking thumbtacks into a keyboard]&rsquo; I could totally go to
        Target &hellip; and buy a set, but, like, &hellip; Keith&rsquo;s
        knives were manufactured in Nazi Germany &hellip; and he gifted
        one to Lemmy from Motorhead &hellip; Yeah! &hellip; I don&rsquo;t
        think I&rsquo;d impress anyone with my kitchen knife set,
        &hellip; one knife bigger than the other.  What would the
        audience say about this?  &lsquo;Is he going to torture that
        keyboard or cook us a mean shish kabob?&rsquo;
      </p>
    </>
  ),
  (
    <>
      <p style={{ marginBottom: 0 }}>
        I have ADHD, which means that I can get easily overwhelmed.  For a
        long time I thought all the daydreaming, all the thoughts in my
        head are like different voices.  And for a long time time I
        thought I had like 1329 different voices in my head.  And one of
        them actually opined that that one-liner from{" "}
        <em>Stephen King&rsquo;s Sleepwalkers</em> &mdash; &lsquo;Cop-kabob!&rsquo;
        &mdash; is the single greatest line of all time in any movie.
        &hellip; I like a line that&rsquo;s short, simple, on-point.  In
        other words, witty.  &lsquo;Stick around&rsquo; &mdash; that&rsquo;s
        another great one.  Arnie hurls that knife, driving it into a
        guy&rsquo;s chest, and says &lsquo;Stick around&rsquo;.  That was a
        great time for film scripting.  I do have a bit of a gripe with
        &lsquo;Oo-la-la&rsquo;, though.  &hellip; Not so witty, that one.
      </p>
    </>
  ),
];

export default function JokesPage() {
  const navigate = useNavigate();
  return (
    <div
      className="min-h-screen"
      style={{ background: PAL.bg, color: PAL.ink }}
      data-testid="jokes-page"
    >
      <TopBar
        theme="studio"
        onBack={() => navigate("/")}
        backLabel="HOME"
        testId="jokes-back-button"
      />
      <div className="relative z-10 max-w-7xl mx-auto flex flex-col md:flex-row">
        <div
          className="md:w-[260px] md:shrink-0 md:min-h-screen flex flex-col pt-4 md:pt-6 px-4 md:px-6 pb-6 md:border-r"
          style={{ borderColor: PAL.border }}
        >
          <NavPane theme="studio" />
        </div>
        <main className="flex-1 flex flex-col pt-4 md:pt-6 px-6 md:px-12 pb-10">
          <div className="max-w-3xl">
            <h1
              className="leading-[1.02] mb-7"
              style={{
                fontFamily: TIMES,
                fontWeight: 500,
                color: PAL.accent,
                fontSize: "clamp(2.4rem, 5vw, 5rem)",
                letterSpacing: "0.005em",
                textShadow:
                  "0 2px 0 rgba(0,0,0,0.55), 0 0 28px rgba(229,200,112,0.22)",
              }}
              data-testid="jokes-title"
            >
              Jokes
            </h1>
            {JOKES.length === 0 ? (
              <p
                className="text-base italic"
                style={{
                  fontFamily: TIMES,
                  color: PAL.muted,
                  lineHeight: 1.65,
                }}
                data-testid="jokes-empty"
              >
                Nothing punny yet &mdash; check back soon.
              </p>
            ) : (
              <ol
                className="space-y-4 text-base"
                style={{
                  fontFamily: TIMES,
                  color: "#BAB09A",
                  lineHeight: 1.65,
                  paddingLeft: "1.4em",
                  listStyle: "decimal",
                }}
                data-testid="jokes-list"
              >
                {JOKES.map((j, i) => (
                  <li key={i} data-testid={`joke-${i}`}>
                    {j}
                  </li>
                ))}
              </ol>
            )}
          </div>
        </main>
      </div>
    </div>
  );
}
